// extracted by mini-css-extract-plugin
module.exports = {"container":"CompanyView_container__3z4mQ","nav":"CompanyView_nav__2ODOS","content":"CompanyView_content__3b2Tg"};